import { Fiat as OldFiatModel } from "@models";
import { BaseAdapter } from "@modules/+new/payments/shared-payments/entities/base-adapter";
import { Logo } from "@modules/+new/payments/shared-payments/entities/logo.model";

export interface Fiat {
	readonly currencyType?: string; // TODO unused?
	readonly defaultSellAmount?: number; // TODO unused?
	readonly hasWallets: boolean;
	readonly id: number;
	readonly pid: string;
	logo: Logo;
	readonly minDepositEuro?: number; // TODO unused?
	readonly minWithdrawEuro?: number; // TODO unused?
	readonly name: string;
	readonly numericCharacterReference: string;
	readonly precision: number;
	readonly symbol: string;
	readonly symbolCharacter: string;
	readonly toEuroRate: number;
	readonly isTransferActive?: boolean; // TODO unused?
	readonly walletMinDeposit?: number; // TODO unused?
	readonly walletMinWithdrawal?: number; // TODO unused?
}

export class FiatAdapter extends BaseAdapter<OldFiatModel, Fiat> {
	public adapt(item: OldFiatModel): Fiat {
		if (!item) {
			return null;
		}

		return {
			hasWallets: item.hasWallet(),
			id: Number(item.getId()),
			pid: item.getPid(),
			logo: {
				defaultUrl: item.getLogo(),
				colorUrl: item.getLogoColor(),
				darkUrl: item.getLogoDark(),
				whiteUrl: item.getLogoWhite()
			},
			name: item.getName(),
			numericCharacterReference: item.getHtmlSign(),
			precision: item.getPrecision(),
			symbol: item.getSymbol(),
			symbolCharacter: item.getSymbolCharacter(),
			toEuroRate: item.toEuroRate(),
			currencyType: item.getCurrencyType(),
			walletMinWithdrawal: Number(item.getMinWalletWithdraw())
		};
	}
}
